import './index.css';
import img from '../../images/Progress-new-3.svg';
import img1 from '../../images/cross-icon-new.svg';




export default function ReviewPage() {
    return (
        <div className='connect-container-bg'>
            <div className='connect-container-main'>
                <div className='connect-steps-container'>
                    <div>
                        <h3>3 <span>/ &nbsp;3 steps</span></h3>
                    </div>
                    <div>
                        <h5>99%</h5>
                    </div>
                </div>
                <div className='connect-progress'>
                    <img src={img} alt="" />
                </div>
                <h2>Review and Finish</h2>
                <p>Your data is almost ready! Let’s review everything and finalize the setup.</p>
                <div className='summary-text'>
                    <h3>Summary</h3>
                </div>
                <div className='map-content-list'>
                    <div className='map-left-data'>
                        <h2>45</h2>
                        <h3>Patients Uploaded</h3>
                    </div>
                    <div className='map-right-data'></div>
                </div>
                <div className='map-content-list'>
                    <div className='map-left-data'>
                        <h2>200</h2>
                        <h3>Records Processed</h3>
                    </div>
                    <div className='map-right-data'></div>
                </div>
                <div className='map-content-list'>
                    <div className='map-left-data'>
                        <h2>1 field needs attention</h2>
                        <h3>Unresolved Issues</h3>
                    </div>
                    <div className='map-right-data'>
                        <img src={img1} alt="" />
                        <span>Needs Review</span>
                    </div>
                </div>
                <div className='login-button-container next-button review-dashboard-btn'>
                    <button>
                        Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
